import { ClientUser } from '../../users/store/types';

export enum ClientActionTypes {
    TOGGLE_CLIENTS_MODAL = 'TOGGLE_CLIENTS_MODAL',
    FETCH_ALL_CLIENTS_STARTED = 'FETCH_ALL_CLIENTS_STARTED',
    FETCH_ALL_CLIENTS_SUCCESSFUL = 'FETCH_ALL_CLIENTS_SUCCESSFUL',
    FETCH_ALL_CLIENTS_FAILED = 'FETCH_ALL_CLIENTS_FAILED',
    UPDATE_CLIENT_STARTED = 'UPDATE_CLIENT_STARTED',
    UPDATE_CLIENT_SUCCESSFUL = 'UPDATE_CLIENT_SUCCESSFUL',
    UPDATE_CLIENT_FAILED = 'UPDATE_CLIENT_FAILED',
    UPDATE_CLIENT_USERS = 'UPDATE_CLIENT_USERS',
    UPDATE_CLIENT_DETAILS = 'UPDATE_CLIENT_DETAILS',
    TOGGLE_DELETE_CLIENT_CONFIRMATION_MODAL = 'TOGGLE_DELETE_CLIENT_CONFIRMATION_MODAL',
    DELETE_CLIENT_STARTED = 'DELETE_CLIENT_STARTED',
    DELETE_CLIENT_SUCCESSFUL = 'DELETE_CLIENT_SUCCESSFUL',
    DELETE_CLIENT_FAILED = 'DELETE_CLIENT_FAILED',
    FETCH_CLIENT_FEATURE_PERMISSIONS_STARTED = 'FETCH_CLIENT_FEATURE_PERMISSIONS_STARTED',
    FETCH_CLIENT_FEATURE_PERMISSIONS_SUCCESSFUL = 'FETCH_CLIENT_FEATURE_PERMISSIONS_SUCCESSFUL',
    FETCH_CLIENT_FEATURE_PERMISSIONS_FAILED = 'FETCH_CLIENT_FEATURE_PERMISSIONS_FAILED',
    RESET_CLIENT_USER_PASSWORD = 'RESET_CLIENT_USER_PASSWORD',
    SET_OPEN_CLIENT_SECTION = 'SET_OPEN_CLIENT_SECTION',
    SET_UPLOAD_CLIENT_TERMS_AND_CONDITIONS_DOCUMENTS = 'SET_UPLOAD_CLIENT_TERMS_AND_CONDITIONS_DOCUMENTS',
    UPLOAD_TERMS_AND_CONDITIONS_DOCUMENT_STARTED = 'UPLOAD_TERMS_AND_CONDITIONS_DOCUMENT_STARTED',
    UPLOAD_TERMS_AND_CONDITIONS_DOCUMENT_SUCCESSFUL = 'UPLOAD_TERMS_AND_CONDITIONS_DOCUMENT_SUCCESSFUL',
    UPLOAD_TERMS_AND_CONDITIONS_DOCUMENT_FAILED = 'UPLOAD_TERMS_AND_CONDITIONS_DOCUMENT_FAILED',
    DOWNLOAD_TERMS_AND_CONDITIONS_DOCUMENT_STARTED = 'DOWNLOAD_TERMS_AND_CONDITIONS_DOCUMENT_STARTED',
    DOWNLOAD_TERMS_AND_CONDITIONS_DOCUMENT_SUCCESSFUL = 'DOWNLOAD_TERMS_AND_CONDITIONS_DOCUMENT_SUCCESSFUL',
    DOWNLOAD_TERMS_AND_CONDITIONS_DOCUMENT_FAILED = 'DOWNLOAD_TERMS_AND_CONDITIONS_DOCUMENT_FAILED',
    EXPORT_CLIENT_DATA_STARTED = 'EXPORT_CLIENT_DATA_STARTED',
    EXPORT_CLIENT_DATA_SUCCESSFUL = 'EXPORT_CLIENT_DATA_SUCCESSFUL',
    EXPORT_CLIENT_DATA_FAILED = 'EXPORT_CLIENT_DATA_FAILED',
    DOWNLOAD_ALL_CLIENT_DATA = 'DOWNLOAD_ALL_CLIENT_DATA',
    FETCH_REJECTED_CHAT_BOT_QUESTIONS_STARTED = 'FETCH_REJECTED_CHAT_BOT_QUESTIONS_STARTED',
    FETCH_REJECTED_CHAT_BOT_QUESTIONS_SUCCESSFUL = 'FETCH_REJECTED_CHAT_BOT_QUESTIONS_SUCCESSFUL',
    FETCH_REJECTED_CHAT_BOT_QUESTIONS_FAILED = 'FETCH_REJECTED_CHAT_BOT_QUESTIONS_FAILED',
    FORGIVE_REJECTED_CHAT_BOT_QUESTIONS_STARTED = 'FORGIVE_REJECTED_CHAT_BOT_QUESTIONS_STARTED',
    FORGIVE_REJECTED_CHAT_BOT_QUESTIONS_SUCCESSFUL = 'FORGIVE_REJECTED_CHAT_BOT_QUESTIONS_SUCCESSFUL',
    FORGIVE_REJECTED_CHAT_BOT_QUESTIONS_FAILED = 'FORGIVE_REJECTED_CHAT_BOT_QUESTIONS_FAILED',
    TOGGLE_QUESTION_TO_FORGIVE = 'TOGGLE_QUESTION_TO_FORGIVE',
    TOGGLE_ALL_REJECTED_QUESTIONS_FOR_USER = 'TOGGLE_ALL_REJECTED_QUESTIONS_FOR_USER',
    SET_CLIENT_SELECTED_FEW_SHOT_AGREEMENT_TYPE_ID = 'SET_CLIENT_SELECTED_FEW_SHOT_AGREEMENT_TYPE_ID'
}

export enum IncompleteDocumentBehaviour {
    USER_ONLY = 'User only',
    USER_AND_ACCESS_GROUPS = 'User and Access Groups',
    USER_AND_ROLE = 'User and Role',
    VISIBLE_TO_ALL = 'Visible to all'
}

export interface ClientOpinion {
    jurisdiction: string;
    focus: string;
    isdaNetting: boolean;
    clientReliance: boolean;
    isdaCollateral: boolean;
    icma: boolean;
    isla: boolean;
}

export interface Client {
    clientId?: number;
    clientName: string;
    description: string;
    users: ClientUser[];
    clientDatasetIds: number[];
    clientFeaturePermissionIds: number[] | null;
    clientOpinions: ClientOpinion[];
    clientTermsAndConditionsDocuments: ClientTermsAndConditionsDocument[];
    fewShotAgreementTypeIds: number[];
    demoClient: number;
    freePages: number;
    maxPages: number | null;
    monthlyTotalPages: number;
    incompleteDocumentBehaviour: IncompleteDocumentBehaviour;
}

export interface ClientFeaturePermissionDB {
    clientFeaturePermissionId: number;
    label: string;
    description: string;
}

export interface ClientTermsAndConditionsDocument {
    clientTermsDocumentId: number;
    description: string;
    location: string;
    mimeType: string;
    createdDate: string;
    clientId: number;
}

export enum ClientSection {
    GENERAL = 'General',
    USERS = 'Users',
    FEATURE_PERMISSIONS = 'Feature Permissions',
    DATASETS = 'Documents',
    OPINIONS = 'Opinions',
    TERMS_AND_CONDITIONS = 'Terms & Conditions',
    REJECTED_QUESTIONS = 'Rejected Chat Bot Questions',
    FEW_SHOT_DOCUMENTS = 'Few Shot Documents'
}

export interface RejectedQuestion {
    documentCustomQueryId: number;
    questionAsked: string;
    dateAsked: string;
    rejected: boolean;
    seriousRejection: boolean;
    forgivenBy: string | null;
    forgivenDate: string | null;
    documentName: string;
}

export interface RejectedQuestionsByUser {
    username: string;
    userId: number;
    userRejectionLevel: RejectionLevel;
    rejectedQuestions: RejectedQuestion[];
}

export enum RejectedQuestionsTab {
    CURRENTLY_REJECTED = 'Currently Rejected Questions',
    FORGIVEN_QUESTIONS = 'Forgiven Rejected Questions'
}

export enum RejectionLevel {
    BLOCKED = 3,
    HIGH_RISK = 2,
    LOW_RISK = 1,
    ALL_FORGIVEN = 0
}

export interface RejectedQuestionsToForgive {
    userId: number;
    questionIds: number[];
}

export interface ClientState {
    modalOpen: boolean;
    clients: Client[];
    selectedClient: Client | null;
    isSaving: boolean;
    confirmDeleteClient: Client | null;
    deletingClient: boolean;
    clientError: null | string;
    availableClientFeaturePermissions: ClientFeaturePermissionDB[];
    openClientSection: ClientSection;
    isUploading: boolean;
    isDownloading: boolean;
    filesToUpload: File[];
    rejectedQuestions: RejectedQuestionsByUser[];
    rejectedQuestionsToForgive: RejectedQuestionsToForgive[];
    isFetchingRejectedQuestions: boolean;
    selectedFewShotAgreementTypeId: number | null;
}
